import { NumberOrNullOrUndefined, StringOrNullOrUndefined } from "src/app/shared/utils";

export class InsuranceV2 {
  id: number = 0;
  name: string = '';
  services?: InsuranceV2Service[];
  notes: InsuranceV2Notes[] = [];
  payer_id: string = '';
  street: string = '';
  street2: string = '';
  city: string = '';
  state: string = '';
  zip: number = 0;
  uses_supervisor_as_provider: boolean = false;
  uses_is_telehealth: boolean = false;
  daily_limit_hours?: number;
  pos_allowed_to_cg?: string[];
  pos_allowed_to_tt?: string[];
  extra_pos_for_bcba?: string[];
  created_at: string | Date = '';
  updated_at: string | Date = '';
  deleted_at: string | Date = '';

  static build = (data: Partial<InsuranceV2>): InsuranceV2 => ({
    ...data,
    services: (data.services as object[])?.map((serviceData) =>
      InsuranceV2Service.build(serviceData)
    ),
    notes: (data.notes as object[])?.map((notesData) =>
      InsuranceV2Notes.build(notesData)
    ) || [],
    payer_id: StringOrNullOrUndefined(data.payer_id) ?? '',
    created_at: data.created_at ? new Date(data.created_at) : '',
    updated_at: data.updated_at ? new Date(data.updated_at) : '',
    deleted_at: data.deleted_at ? new Date(data.deleted_at) : '',
    id: NumberOrNullOrUndefined(data.id) ?? 0,
    name: StringOrNullOrUndefined(data.name) ?? '',
    street: StringOrNullOrUndefined(data.street) ?? '',
    street2: StringOrNullOrUndefined(data.street2) ?? '',
    city: StringOrNullOrUndefined(data.city) ?? '',
    state: StringOrNullOrUndefined(data.state) ?? '',
    zip: NumberOrNullOrUndefined(data.zip) ?? 0,
    uses_supervisor_as_provider: Boolean(data.uses_supervisor_as_provider),
    uses_is_telehealth: Boolean(data.uses_is_telehealth),
    pos_allowed_to_cg: Array.isArray(data?.pos_allowed_to_cg) ? data.pos_allowed_to_cg : [],
    pos_allowed_to_tt: Array.isArray(data?.pos_allowed_to_tt) ? data.pos_allowed_to_tt : [],
    extra_pos_for_bcba: Array.isArray(data?.extra_pos_for_bcba) ? data.extra_pos_for_bcba : [],
  });
}

export class InsuranceV2Service {
  code: string = '';
  provider: string = '';
  description: string = '';
  unit_price: number = 0;
  hourly_fee: number = 0;
  max_allowed: string = '';
  md1: string = ''; //TODO
  md2: string = ''; //TODO
  type: 'rbt' | 'bcba' | 'all' = 'all'; //TODO
  multiplier = 1; //TODO
  static build = (data: object): InsuranceV2Service => {
    if (!data) return new InsuranceV2Service();

    const source = data as Record<string, unknown>;

    // Handle code with or without modifiers
    let code = (source['code'] as string) || '';
    let md1 = '';
    let md2 = '';

    if (typeof code === 'string' && code.includes(' ')) {
      const codes = code.split(' ');
      code = codes[0];
      md1 = codes[1] || '';
      md2 = codes[2] || '';
    }

    // Determine the unit price value from either unit_price or unit_prize
    const unitPriceValue = source['unit_price'] !== undefined
      ? Number(source['unit_price'])
      : source['unit_prize'] !== undefined
        ? Number(source['unit_prize'])
        : 0;

    const result = {
      ...source,
      code: code,
      provider: (source['provider'] as string) ?? '',
      description: (source['description'] as string) ?? '',
      unit_price: unitPriceValue,
      hourly_fee: source['hourly_fee'] !== undefined ? Number(source['hourly_fee']) : 0,
      max_allowed: (source['max_allowed'] as string) ?? '',
      md1: md1,
      md2: md2,
      type: source['type'] as 'rbt' | 'bcba' | 'all',
      multiplier: source['multiplier'] ? Number(source['multiplier']) : 1,
    };
    // FIXES
    result.type =
      result.provider?.toLowerCase() === 'bcba' ||
      result.provider?.toLowerCase() === 'bcaba'
        ? 'bcba'
        : result.provider?.toLowerCase() === 'rbt'
        ? 'rbt'
        : 'all';

    return result;
  };
}

export class InsuranceV2Notes {
  note: string = '';
  static build = (data: object): InsuranceV2Notes => ({
    note: ((data as Record<string, unknown>)['note'] as string) ?? '',
  });
}
